// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TiefgaragenbeschichtungV2RouteImport } from './routes/tiefgaragenbeschichtung-v2'
import { Route as TiefgaragenbeschichtungRouteImport } from './routes/tiefgaragenbeschichtung'
import { Route as ReportingRouteImport } from './routes/reporting'
import { Route as IndustriebodenbeschichtungV2RouteImport } from './routes/industriebodenbeschichtung-v2'
import { Route as IndustriebodenbeschichtungRouteImport } from './routes/industriebodenbeschichtung'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminConversionsRouteImport } from './routes/admin/conversions'

const TiefgaragenbeschichtungV2Route = TiefgaragenbeschichtungV2RouteImport.update({
            id: '/tiefgaragenbeschichtung-v2',path: '/tiefgaragenbeschichtung-v2',getParentRoute: () => rootRouteImport
          })
const TiefgaragenbeschichtungRoute = TiefgaragenbeschichtungRouteImport.update({
            id: '/tiefgaragenbeschichtung',path: '/tiefgaragenbeschichtung',getParentRoute: () => rootRouteImport
          })
const ReportingRoute = ReportingRouteImport.update({
            id: '/reporting',path: '/reporting',getParentRoute: () => rootRouteImport
          })
const IndustriebodenbeschichtungV2Route = IndustriebodenbeschichtungV2RouteImport.update({
            id: '/industriebodenbeschichtung-v2',path: '/industriebodenbeschichtung-v2',getParentRoute: () => rootRouteImport
          })
const IndustriebodenbeschichtungRoute = IndustriebodenbeschichtungRouteImport.update({
            id: '/industriebodenbeschichtung',path: '/industriebodenbeschichtung',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AdminConversionsRoute = AdminConversionsRouteImport.update({
            id: '/admin/conversions',path: '/admin/conversions',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,IndustriebodenbeschichtungRoute: IndustriebodenbeschichtungRoute,IndustriebodenbeschichtungV2Route: IndustriebodenbeschichtungV2Route,ReportingRoute: ReportingRoute,TiefgaragenbeschichtungRoute: TiefgaragenbeschichtungRoute,TiefgaragenbeschichtungV2Route: TiefgaragenbeschichtungV2Route,AdminConversionsRoute: AdminConversionsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)